import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

/**
 * Wrapper component that provides reCAPTCHA context only to pages that need it.
 * Use this to wrap pages with forms that require reCAPTCHA protection.
 */
export default function RecaptchaWrapper({ children }) {
  if (!RECAPTCHA_SITE_KEY) {
    return children;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_SITE_KEY}
      language="nl"
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}
